var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _vm.IsAdmin()
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.modal-add-department",
                                  modifiers: { "modal-add-department": true },
                                },
                              ],
                              attrs: { variant: "primary" },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Add New Department "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-modal",
                        {
                          ref: "addDepartment",
                          attrs: {
                            id: "modal-add-department",
                            "ok-only": "",
                            "ok-title": "Add",
                            centered: "",
                            size: "lg",
                            title: "Add Department",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("AddDepartment", {
                            on: { DepartmentAdded: _vm.closeAddModal },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-col", {
                    staticClass: "my-1",
                    attrs: { md: "4", sm: "8" },
                  }),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mb-2",
                      staticStyle: { position: "relative", "z-index": "1" },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-danger", size: "sm" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredDepartments,
                          fields: _vm.department_fields,
                          "filter-included-fields": _vm.filterOn,
                        },
                        on: { filtered: _vm.onFiltered },
                        scopedSlots: _vm._u([
                          {
                            key: "head(departmentName)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort(
                                              "departmentName"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Department Name")]
                                    ),
                                    _c("b-form-input", {
                                      attrs: {
                                        placeholder:
                                          "Filter by Department Name",
                                        size: "sm",
                                      },
                                      on: { input: _vm.applyFilters },
                                      model: {
                                        value: _vm.filters.departmentName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filters,
                                            "departmentName",
                                            $$v
                                          )
                                        },
                                        expression: "filters.departmentName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "align-middle text-body",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName:
                                              "v-b-modal.modal-edit-department",
                                            modifiers: {
                                              "modal-edit-department": true,
                                            },
                                          },
                                        ],
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editDepartment(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "EditIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Edit")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeDepartment(
                                              data.item.departmentId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "TrashIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Delete")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        attrs: { disabled: !_vm.IsAdmin() },
                                        on: {
                                          click: function ($event) {
                                            return _vm.AddDesignation(
                                              data.item.departmentId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: { icon: "PlusIcon" },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle ml-50" },
                                          [_vm._v("Designation")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center mb-1" },
                        [
                          _vm.loading
                            ? _c("b-spinner", {
                                staticStyle: { width: "3rem", height: "3rem" },
                                attrs: {
                                  variant: "success",
                                  label: "Spinning",
                                  block: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "editDepartment",
                          attrs: {
                            id: "modal-edit-department",
                            "ok-only": "",
                            "ok-title": "Edit",
                            centered: "",
                            size: "lg",
                            title: "Edit Department",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("EditDepartment", {
                            attrs: { department: _vm.currentDepartment },
                            on: { DepartmentUpdated: _vm.closeEditModal },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-modal",
                    {
                      ref: "addDesignation",
                      attrs: {
                        id: "modal-add-designation",
                        "ok-only": "",
                        "ok-title": "Add",
                        centered: "",
                        size: "lg",
                        title: "Add Designation",
                        "hide-footer": true,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("validation-observer", {
                            ref: "AddDesignationForm",
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var invalid = ref.invalid
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "b-form",
                                      {
                                        on: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return _vm.formSubmitted($event)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "ml-1" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "Working Hours",
                                                              "label-for":
                                                                "workingHours",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  name: "Working Hours",
                                                                  rules:
                                                                    "required|max_working_hours",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "b-form-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    name: "workingHours",
                                                                                    placeholder:
                                                                                      "Working Hours",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm.workingHours,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.workingHours =
                                                                                          $$v
                                                                                      },
                                                                                    expression:
                                                                                      "workingHours",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "small",
                                                                              {
                                                                                staticClass:
                                                                                  "text-danger",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    errors[0]
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "Designation Name",
                                                              "label-for":
                                                                "designationName",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  name: "Designation Name",
                                                                  rules:
                                                                    "required",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "b-form-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    name: "designationName",
                                                                                    placeholder:
                                                                                      "Designation Name",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm.designationName,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.designationName =
                                                                                          $$v
                                                                                      },
                                                                                    expression:
                                                                                      "designationName",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "small",
                                                                              {
                                                                                staticClass:
                                                                                  "text-danger",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    errors[0]
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "Minimum Salary",
                                                              "label-for":
                                                                "minimumSalary",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  name: "minimumSalary",
                                                                  rules: [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "Minimum Salary is required",
                                                                    },
                                                                    {
                                                                      numeric_decimal: true,
                                                                      message:
                                                                        "Please enter a valid number",
                                                                    },
                                                                    {
                                                                      validate:
                                                                        function (
                                                                          value
                                                                        ) {
                                                                          return (
                                                                            value >=
                                                                              0 ||
                                                                            "Salary cannot be negative"
                                                                          )
                                                                        },
                                                                      message:
                                                                        "Salary cannot be negative",
                                                                    },
                                                                  ],
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "b-form-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    type: "number",
                                                                                    name: "minimumSalary",
                                                                                    placeholder:
                                                                                      "Minimum Salary",
                                                                                  },
                                                                                on: {
                                                                                  input:
                                                                                    _vm.checkNegative,
                                                                                  blur: _vm.validate,
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm.minimumSalary,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.minimumSalary =
                                                                                          _vm._n(
                                                                                            $$v
                                                                                          )
                                                                                      },
                                                                                    expression:
                                                                                      "minimumSalary",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "small",
                                                                              {
                                                                                staticClass:
                                                                                  "text-danger",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    errors[0]
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "6" } },
                                                      [
                                                        _c(
                                                          "b-form-group",
                                                          {
                                                            attrs: {
                                                              label:
                                                                "Maximum Salary",
                                                              "label-for":
                                                                "maximumSalary",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  name: "maximumSalary",
                                                                  rules: [
                                                                    {
                                                                      required: true,
                                                                      message:
                                                                        "Minimum Salary is required",
                                                                    },
                                                                    {
                                                                      numeric_decimal: true,
                                                                      message:
                                                                        "Please enter a valid number",
                                                                    },
                                                                    {
                                                                      validate:
                                                                        function (
                                                                          value
                                                                        ) {
                                                                          return (
                                                                            value >=
                                                                              0 ||
                                                                            "Salary cannot be negative"
                                                                          )
                                                                        },
                                                                      message:
                                                                        "Salary cannot be negative",
                                                                    },
                                                                  ],
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "b-form-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    type: "number",
                                                                                    name: "maximumSalary",
                                                                                    placeholder:
                                                                                      "Maximum Salary",
                                                                                  },
                                                                                on: {
                                                                                  input:
                                                                                    _vm.checkNegative,
                                                                                  blur: _vm.validate,
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm.maximumSalary,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.maximumSalary =
                                                                                          _vm._n(
                                                                                            $$v
                                                                                          )
                                                                                      },
                                                                                    expression:
                                                                                      "maximumSalary",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "small",
                                                                              {
                                                                                staticClass:
                                                                                  "text-danger",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    errors[0]
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-content-between mb-1",
                                                    attrs: { md: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          type: "submit",
                                                          variant: "primary",
                                                          disabled: invalid,
                                                        },
                                                      },
                                                      [_vm._v(" Save ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("b-row"),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  responsive: "",
                                  "per-page": _vm.perPage1,
                                  "current-page": _vm.currentPage1,
                                  items: _vm.designationList,
                                  fields: _vm.designation_fields,
                                  "filter-included-fields": _vm.filterOn,
                                },
                              }),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("b-pagination", {
                                    staticClass: "my-0",
                                    attrs: {
                                      "total-rows": _vm.totalRows1,
                                      "per-page": _vm.perPage1,
                                      align: "center",
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.currentPage1,
                                      callback: function ($$v) {
                                        _vm.currentPage1 = $$v
                                      },
                                      expression: "currentPage1",
                                    },
                                  }),
                                  _c("b-form-group", [
                                    _vm._v(
                                      " Showing " +
                                        _vm._s(
                                          _vm.totalRows1 > 0
                                            ? _vm.perPage1 *
                                                (_vm.currentPage1 - 1) +
                                                1
                                            : 0
                                        ) +
                                        " to " +
                                        _vm._s(
                                          _vm.totalRows1 > 0
                                            ? Math.min(
                                                _vm.perPage1 * _vm.currentPage1,
                                                _vm.totalRows1
                                              )
                                            : 0
                                        ) +
                                        " of " +
                                        _vm._s(
                                          _vm.totalRows1 > 0
                                            ? _vm.totalRows1
                                            : 0
                                        ) +
                                        " entries "
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center mb-1",
                                },
                                [
                                  _vm.loading
                                    ? _c("b-spinner", {
                                        staticStyle: {
                                          width: "3rem",
                                          height: "3rem",
                                        },
                                        attrs: {
                                          variant: "success",
                                          label: "Spinning",
                                          block: "",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }